<template>
    <div>
        <div class="crud-title-flex">
            <span>
                <strong>
                    <translate>TECHNICAL_ASSESSMENT_OF_SERVICES</translate>
                </strong>
            </span>
            <span class="crud-title-items-flex">
                <span>
                    <translate>COD_WITHOUT_DOT</translate>:<strong>{{ code }}</strong>
                </span>
                <span>
                    <translate>REV</translate>: <strong>{{ procedureRevision }}</strong>
                </span>
            </span>
        </div>
        <hr>
        <div class="headers-information-container">
            <div class="headers-informations">
                <span>
                    <translate>PROCESS_NUMBER</translate>: {{ processNumber }}
                </span>
                <span>
                    <translate>REV</translate>: {{ technicalRevision }}
                </span>
                <span>
                    <translate>CREATED_DATE</translate>: {{ createdAt }}
                </span>
            </div>
        </div>
    </div>
</template>
<script>

import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'

@Component({
  name: 'TechnicalAssesmentPageHeader',
  components: {},
  props: {
    code: String,
    procedureRevision: String,
    processNumber: String,
    technicalRevision: String,
    createdAt: String
  }
})
class TechnicalAssesmentPageHeader extends Vue {

}
export default TechnicalAssesmentPageHeader

</script>
<style lang="stylus" scoped>
 strong {
    font-weight: 500;
}

hr {
    background-color: rgba(128, 128, 128, 0.1);
    border-color: rgba(128, 128, 128, 0.1);
}

.crud-title-flex {
    display: flex;
    justify-content: space-between;
    font-size: 1.35em;
    margin-top:10px

}
.crud-title-items-flex {
    display: flex;
    gap:15px
}
.headers-informations {
    display: flex;
    gap:15px
    font-size: 1.3em
    margin-bottom:25px;
}

  </style>
